import React from 'react'

import { CustomTheme, B2CCard } from '@masfront/common-b2c'
import { useFormatMessage } from '@masfront/common-i18n'

import { makeStyles } from '@material-ui/core/styles'

import { DocumentType } from '~/common/model'
import { getFullName, getSegmentText } from '~/customer/helpers/customer.helpers'
import useCustomer from '~/customer/useCustomer'
import LineItem from '~/ui/components/LineItem/LineItem'
import { getLanguageFromCode, formatDate } from '~/utils'

const useStyles = makeStyles((theme: CustomTheme) => {
  return {
    lineItem: {
      marginBottom: theme.spacing(5),
    },
  }
})

const CustomerCard: React.FC = () => {
  const { customer } = useCustomer()
  const classes = useStyles()
  const t = useFormatMessage()

  return (
    <B2CCard title="Titular" dataHookPrefix="customer">
      {customer && (
        <>
          <LineItem
            dataHook="customer-segment"
            className={classes.lineItem}
            primaryText="Segmento - ID"
            secondaryText={`${getSegmentText(customer.sector, t)} ${
              customer.id ? ` - ${customer.id}` : ''
            }`}
            vertical
          />
          <LineItem
            dataHook="customer-fullName"
            className={classes.lineItem}
            primaryText={`${customer.business ? 'Nombre de la empresa' : 'Nombre y Apellidos'}`}
            secondaryText={customer.business ? customer.business.company : getFullName(customer)}
            vertical
          />
          <LineItem
            dataHook="customer-documentId"
            className={classes.lineItem}
            primaryText={
              (customer.documentType === DocumentType.PASSPORT
                ? 'Pasaporte'
                : customer.documentType) || 'NIF'
            }
            secondaryText={customer.documentValue}
            vertical
          />

          {customer.business ? (
            customer.business?.createdDate && (
              <LineItem
                dataHook="customer-birthDate"
                className={classes.lineItem}
                primaryText="Fecha de constitución"
                secondaryText={formatDate(customer.business?.createdDate)}
                vertical
              />
            )
          ) : (
            <LineItem
              dataHook="customer-birthDate"
              className={classes.lineItem}
              primaryText="Fecha de nacimiento"
              secondaryText={formatDate(customer.personal?.birthDate)}
              vertical
            />
          )}
          <LineItem
            dataHook="customer-originCountry"
            className={classes.lineItem}
            primaryText="País de origen"
            secondaryText={customer.originCountryCode || '-'}
            vertical
          />
          <LineItem
            dataHook="customer-language"
            className={classes.lineItem}
            primaryText="Idioma"
            secondaryText={getLanguageFromCode(customer.languageCode)}
            vertical
          />
        </>
      )}
    </B2CCard>
  )
}

export default CustomerCard
